import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchUsers = createAsyncThunk(
    'userSlice/fetchUsers',
    async (obj) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}${obj.type == 'admin' ? '/admin/getUserDetails' : '/user/getUserDetails'}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${obj.token}`
            },
        });
        const data = await response.json();
        return data;
    }
);

export const fetchUserSubscription = createAsyncThunk(
    'userSlice/fetchUserSubscription',
    async (token) => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/user/getUserSubscription`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${token}`
            },
        });
        const data = await response.json();
        return data;
    }
);

const initialState = {
    value: undefined,
    loading: false,
    pageLoading: true,
    subscriptionLoading: false,
    userSubscription: undefined,
    freeSubscription: 10,
    unlimited: false
};

const AuthSlice = createSlice({
    name: 'userSlice',
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.value = action.payload.userDetails;
        },
        setPageLoading: (state, action) => {
            state.pageLoading = action.payload.pageLoading;
        },
        setfreeSubscription : (state, action)=>{
            state.freeSubscription = action.payload.freeSubscription;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload?.userDetails) {
                    state.value = action.payload?.userDetails;
                    state.freeSubscription = action.payload?.userDetails?.free_count;
                } else {
                    localStorage.removeItem('adminAuthToken')
                    localStorage.removeItem('authToken')
                }
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.loading = false;
                localStorage.removeItem('adminAuthToken')
                localStorage.removeItem('authToken')
                state.value = undefined;
            });

        builder
            .addCase(fetchUserSubscription.pending, (state) => {
                state.subscriptionLoading = true;
            })
            .addCase(fetchUserSubscription.fulfilled, (state, action) => {
                state.subscriptionLoading = false;
                if (action.payload?.userSubscription) {
                    state.userSubscription = action.payload?.userSubscription;
                    if(action.payload?.userSubscription?.request_type == 2 && action.payload?.expire_on > Date.now()){
                       state.unlimited = true;
                    }
                }else {
                    state.userSubscription = undefined;
                    state.freeSubscription = state.freeSubscription -1 
                }
            })
            .addCase(fetchUserSubscription.rejected, (state, action) => {
                state.subscriptionLoading = false;
                state.userSubscription = undefined;
            });
        
    },
});


export const { setUser, setPageLoading, setfreeSubscription } = AuthSlice.actions;

export default AuthSlice.reducer;